<template>
  <div class="wrapper" :class="eventClass">
    <small class="vuecal__event-time">
      <div class="header">
        <div class="flex-wrapper">
          <span class="header__left">{{ name }}</span>
          <span class="header__right">
            <span v-if="event.reserved_slot">
              <a-icon
                :type="event.reserved_slot.course_is_group ? 'team' : 'user'"
              />
              <a-icon
                v-if="event.reserved_slot.is_exam"
                type="snippets"
                class="exam-icon"
              />
            </span>
          </span>
        </div>
        <div class="language">
          <span v-if="event.reserved_slot">
            {{ event.reserved_slot.language_name }}
          </span>
        </div>
      </div>
      <div class="date">
        <span>
          {{ getTimeOnly(event.startDate) }} – {{ getTimeOnly(event.endDate) }}
        </span>
      </div>
    </small>
  </div>
</template>

<script>
import { get } from 'lodash'

export default {
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  computed: {
    eventClass() {
      return this.event.slot_type
    },
    name() {
      return get(
        this.event,
        ['reserved_slot', 'course_name'],
        this.event.lecturer_str
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  height: 100%;
  cursor: pointer;
  padding: 5px 6px;
  font-size: 14px;
  border-radius: 6px;
  white-space: nowrap;
  overflow: hidden;
  border: 1px solid transparent; // reserve border space so a text inside every cell is aligned properly
}

.flex-wrapper {
  display: flex;
  justify-content: space-between;
}

.header {
  font-size: 1em;
  overflow: hidden;
  line-height: 1em;

  &__left {
    font-weight: 700;
    text-align: left;
  }

  &__right {
    flex-shrink: 0;
  }
}

.language {
  text-align: left;

  &:not(:empty) {
    padding-bottom: 2px;
  }
}

.date {
  text-align: left;
  font-size: 0.8em;
  overflow: hidden;
}

.available {
  background-color: #ebebeb;
}

.pending {
  background: white;
  border: 1px solid #b5f5ec;
}

.cancelled {
  background: #ffccc7;
  color: #820014;
}

.confirmed {
  background-color: #b5f5ec;
  color: #006d75;
}

.exam-icon {
  margin-left: 3px;
}
</style>
